import React from "react";

const Preloader = () => {
  return (
    <div id="ploader">
      <div className="loader-content">
        <div className="loader"></div>
      </div>
    </div>
  );
};

export default Preloader;
